import { Utils } from '../../../utils/utils';

/**
 * Spits our a deprecation warning in the console if
 * useIcon prop is used for table actions
 * @param action
 */
export const actionDeprecation = (action) => {
  if (action.useIcon) {
    Utils.deprecationWarning(
      { tagName: 'fluid-table' } as HTMLFluidTableElement,
      'rowActions',
      'useIcon',
      'icon',
      'FluidIconConfig'
    );
  }
};
